import { forwardRef } from "react";
import { NumberInput } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomNumberInput = forwardRef(
  (
    {
      labelProps = {
        style: { fontWeight: "700" },
        className: "text-neutral-500",
      },
      size,
      ...props
    },
    ref
  ) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "md" : "sm");
    return <NumberInput labelProps={labelProps} ref={ref} size={responsiveSize} {...props} />;
  }
);

export default CustomNumberInput;
